module.exports = __webpack_public_path__ + "img/Nicole+Jon-71.bbc751f1.jpg";